<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit">
      <div class="table-body">
        <div style="overflow: hidden; margin: 0 0 8px 0">
          <div class="left">会员套餐</div>
          <div class="right"></div>
        </div>
        <el-table
          id="outTable"
          border
          :data="tableData"
          style="width: 100%"
          lazy
        >
          <el-table-column label="VIP等级" prop="vipType" align="center">
            <template slot-scope="scope">
              <span>VIP{{ scope.row.vipType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收费标准" prop="cost" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.cost }}</span>
            </template>
          </el-table-column>
          <el-table-column label="子账号数量" prop="accountNum" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.accountNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="店铺数量" prop="shopNum" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.shopNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设计次数" prop="designNum" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.designNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="图库容量（M）" prop="mapSpace" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.mapSpace }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间单位" prop="mapSpace" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.timeType == "01" ? "年" : "月" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="oper" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleShowDialog(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table-body">
        <div style="overflow: hidden; margin: 0 0 8px 0">
          <div class="left">增值服务</div>
          <div class="right"></div>
        </div>
        <el-table
          id="outTable"
          border
          :data="tableDataAdd"
          style="width: 100%"
          lazy
        >
          <el-table-column label="服务项目" prop="serviceItem" align="center">
            <template slot-scope="scope">
              <span>{{ getName(scope.row.serviceItem) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="serviceNum" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.serviceNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="价格" prop="price" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间单位" prop="mapSpace" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.timeType == "01" ? "年" : "月" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="oper" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleShowDialogAdd(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="编辑会员套餐"
      width="50%"
      :visible.sync="noteDialogVisible"
      class="note-dialog"
    >
      <el-row>
        <el-col>
          <el-form
            ref="form"
            :model="form"
            label-position="left"
            label-width="100px"
          >
            <el-form-item prop="vipType" label="VIP等级" required>
              VIP{{ form.vipType }}
            </el-form-item>
            <el-form-item prop="cost" label="收费标准" required>
              <el-input
                v-model="form.cost"
                placeholder="请输入收费标准"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="accountNum" label="子账号数量" required>
              <el-input
                v-model="form.accountNum"
                placeholder="请输入子账号数量"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="shopNum" label="店铺数量" required>
              <el-input
                v-model="form.shopNum"
                placeholder="请输入店铺数量"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="designNum" label="设计次数" required>
              <el-input
                v-model="form.designNum"
                placeholder="请输入设计次数"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="mapSpace" label="图库容量" required>
              <el-input
                v-model="form.mapSpace"
                placeholder="请输入图库容量"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="timeType" label="时间单位" required>
              <el-select
                clearable
                filterable
                style="width: 100%"
                v-model="form.timeType"
                placeholder="请选择"
                class="input"
                size="small"
              >
                <el-option label="年" value="01"> </el-option>
                <el-option label="月" value="02"> </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave" size="small"
          >确 定</el-button
        >
        <el-button @click="noteDialogVisible = false" size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="编辑增值服务"
      width="50%"
      :visible.sync="noteDialogAddVisible"
      class="note-dialog"
    >
      <el-row>
        <el-col>
          <el-form
            ref="formAdd"
            :model="formAdd"
            label-position="left"
            label-width="100px"
          >
            <el-form-item prop="serviceItem" label="服务项目" required>
              {{ getName(formAdd.serviceItem) }}
            </el-form-item>
            <el-form-item prop="serviceNum" label="数量" required>
              <el-input
                v-model="formAdd.serviceNum"
                placeholder="请输入数量"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="price" label="价格" required>
              <el-input
                v-model="formAdd.price"
                placeholder="请输入价格"
                clearable
                size="small"
              />
            </el-form-item>
             <el-form-item prop="timeType" label="时间单位" required>
              <el-select
                clearable
                filterable
                style="width: 100%"
                v-model="formAdd.timeType"
                placeholder="请选择"
                class="input"
                size="small"
              >
                <el-option label="年" value="01"> </el-option>
                <el-option label="月" value="02"> </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSaveAdd" size="small"
          >确 定</el-button
        >
        <el-button @click="noteDialogAddVisible = false" size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"

import {
  listVarUse,
  editVarUse,
  addVarUse,
  deleteVar,
} from "@/api/sysSupport/var"

import {
  getSeriveList,
  getAddServiceList,
  getVipServiceList,
  buyVipService,
  buyAddService,
  updateList,
  updateListAdd,
} from "@/api/mine/service"

export default {
  name: "variableReference",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      noteDialogVisible: false,
      noteDialogAddVisible: false,
      form: {
        vipType: "",
        cost: "",
        accountNum: "",
        shopNum: "",
        designNum: "",
        mapSpace: "",
        timeType: "",
      },
      formAdd: {
        serviceItem: "",
        serviceItem: "",
        serviceNum: "",
        price: "",
        timeType: ""
      },
      total: 0,
      loading: false,
      tableData: [],
      tableDataAdd: [],
      dialogTitle: "",
    }
  },
  mounted() {
    this.loadData()
    this.loadDataAdd()
  },
  methods: {
    loadData() {
      this.startLoading()
      let params = {}
      getVipServiceList(params)
        .then((res) => {
          this.loading = false
          this.tableData = res
          this.endLoading()
        })
        .catch((err) => {
          this.endLoading()
          console.error(err)
        })
    },
    loadDataAdd() {
      this.startLoading()
      let params = {}
      getAddServiceList(params)
        .then((res) => {
          this.tableDataAdd = res
          this.endLoading()
        })
        .catch((err) => {
          this.endLoading()
          console.error(err)
        })
    },
    getName(name) {
      if (name == "ACCOUNT") {
        return "子账号数量"
      } else if (name == "SHOP") {
        return "店铺数量"
      } else if (name == "DESIGN") {
        return "设计次数"
      } else if (name == "MAP") {
        return "图库容量"
      }
    },
    handleShowDialog(data) {
      this.form = this._.clone(data)
      this.noteDialogVisible = true
    },
    handleShowDialogAdd(data) {
      this.formAdd = this._.clone(data)
      this.noteDialogAddVisible = true
    },
    handleSave() {
      let _self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          updateList([_self.form]).then((response) => {
            if (response.code == "200") {
              _self.msgSuccess("修改成功！")
              _self.noteDialogVisible = false
              _self.loadData()
            } else {
              _self.msgError("修改失败！")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleSaveAdd() {
      let _self = this
      this.$refs["formAdd"].validate((valid) => {
        if (valid) {
          updateListAdd([_self.formAdd]).then((response) => {
            if (response.code == "200") {
              _self.msgSuccess("修改成功！")
              _self.noteDialogAddVisible = false
              _self.loadDataAdd()
            } else {
              _self.msgError("修改失败！")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleDelete(row) {
      this.$confirm("确认删除变量？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteVar(row.id).then((response) => {
          if (response.code === 200) {
            this.msgSuccess("删除成功！")
            this.loadData()
          } else {
            this.msgError("删除失败！")
          }
        })
      })
    },
  },
}
</script>

<style scoped></style>
